const reportDummy = [
    { id: 1, content: '스팸 또는 광고(커미션, 상점 홍보 등)'},
    { id: 2, content: '폭력적인 콘텐츠(언어적, 심리적, 신체적 등)'},
    { id: 3, content: '거래 금지 및 부적절한 품목'},
    { id: 4, content: '거래 비매너(늦은 배송, 거래 파기 등)'},
    { id: 5, content: '기타(최대 100자 입력)'},
]
export default reportDummy;